// // utils/session.ts

// interface LoginResponse {
//   accessToken: string;
//   refreshToken:string;
//   warning?:string;
//   user: {
//     orgId: string;
//     orgName: string;
//     userId: string;
//   };
// }
// const SESSION_KEY = "session";
// export const setSession = (loginResponse: LoginResponse) => {
//   const sessionData = {
//     token: loginResponse.accessToken,
//     user: loginResponse.user,
//     lastActivity: Date.now(),
//     warning: loginResponse.warning || null 
//   };
//   sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
// };

// export const getSession = () => {
//   const sessionStr = sessionStorage.getItem(SESSION_KEY);
//   if (!sessionStr) return null;

//   try {
//     const sessionData = JSON.parse(sessionStr);
//     return sessionData;
//   } catch {
//     sessionStorage.removeItem(SESSION_KEY);
//     return null;
//   }
// };

// export const updateLastActivity = () => {
//   const session = getSession();
//   if (session) {
//     session.lastActivity = Date.now();
//     sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
//   }
// };

// export const isSessionExpired = (timeoutMinutes = 5) => {
//   const session = getSession();
//   if (!session) return true;

//   const now = Date.now();
//   const inactiveTime = now - session.lastActivity;
//   return inactiveTime > timeoutMinutes * 60 * 1000;
// };

// export const clearSession = () => {
//   sessionStorage.removeItem(SESSION_KEY);
// };
const SESSION_KEY = "app_session";
 
interface SessionData {
  accessToken:   string;
  refreshToken:  string;
  sessionExpiry: number;   // epoch ms — when the ACCESS token expires (30 min)
  lastActivity : number;  
  user: {
    userId:  string;
    orgId:   string;
    orgName: string;
    name?:   string;
    email?:  string;
  };
  warning?: string | null;
}
 
/**
 * Store the login response in sessionStorage.
 * Uses sessionStorage (tab-scoped) rather than localStorage so
 * closing the tab clears the session — more secure for accounting software.
 * The refresh token itself lives in localStorage (persistent across tabs).
 */
export const setSession = (loginResponse: {
  accessToken:  string;
  refreshToken: string;
  warning?:     string | null;
  user: {
    userId:  string;
    orgId:   string;
    orgName: string;
    name?:   string;
    email?:  string;
  };
}): void => {
  const session: SessionData = {
    accessToken:   loginResponse.accessToken,
    refreshToken:  loginResponse.refreshToken,
    sessionExpiry: Date.now() + 30 * 60 * 1000,  // 30 minutes (matches JWT expiry)
    user:          loginResponse.user,
    warning:       loginResponse.warning ?? null,
    lastActivity:  Date.now(),
  };
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
};
 
/**
 * Retrieve session. Returns null if:
 *  - nothing is stored
 *  - JSON parse fails
 *  - session has expired (accessToken would be invalid anyway)
 *
 * NOTE: Even if sessionExpiry has passed, the user may still have a valid
 * refresh token — axiosInstance will handle the silent refresh. This check
 * is only used by LoginPage to decide whether to show the login form or
 * redirect to /dashboard immediately.
 */
export const getSession = (): SessionData | null => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
 
    const session: SessionData = JSON.parse(raw);
 
    // If stored session is missing required fields, treat as invalid
    if (!session.accessToken || !session.sessionExpiry) return null;
 
    return session;
  } catch {
    return null;
  }
};
 
/**
 * Clear session — called on logout.
 * localStorage tokens are cleared by handleLogout in AuthService.
 */
export const clearSession = (): void => {
  sessionStorage.removeItem(SESSION_KEY);
};
//Added from old code
export const updateLastActivity = () => {
  const session = getSession();
  if (session) {
    session.lastActivity = Date.now();
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
  }
};

export const isSessionExpired = (timeoutMinutes = 5) => {
  const session = getSession();
  if (!session) return true;

  const now = Date.now();
  const inactiveTime = now - session.lastActivity;
  return inactiveTime > timeoutMinutes * 60 * 1000;
};